// @flow
const configDevelop = {
  name: "configDevelop",
  baseName: "",
  oldDomainUrl: "https://zoom-ops-develop.stg.rivigo.com/#/",
  zoomApiUrl: "https://zoom-api-develop.stg.rivigo.com",
  loginUrl:
    "https://login.stg.rivigo.com/sso/login?client_id=ticketing-develop-client",
  logoutUrl: "https://login.stg.rivigo.com",
  ticketingApiUrl: "https://zoom-ticketing-develop.stg.rivigo.com",
  analyticsFlag: true,
  analyticsId: "UA-109460587-2",
  primeOpcApiUrl: "https://opc-api.stg.rivigo.com"
};

export default configDevelop;



// WEBPACK FOOTER //
// ./app/configs/configDevelop.js